
import {
  Component,
  Vue
  // Prop,
  // Model,
  // Provide,
  // Watch
} from "vue-property-decorator";
import { State, Mutation } from "vuex-class";
import { objAny } from "../../common/common-interface";
@Component
export default class SysContentHeader extends Vue {
  // @State sys: objAny;
  @State("sys") sys!: objAny;
  // @Mutation("UP_GOROUTER") UP_GOROUTER: (index: number) => void;
  @Mutation("UP_GOROUTER") UP_GOROUTER!: Function;
  private win: objAny = window;
  private tagList: object[] = [{ name: "用户管理" }];
  public handleClose(item: objAny, index: number): void {
    if (item.url != this.$route.path) {
      this.UP_GOROUTER(index);
    } else {
      let url = "";
      if (this.sys.goRouter[index + 1]) {
        url = this.sys.goRouter[index + 1].url;
      } else {
        url = this.sys.goRouter[index - 1].url;
      }
      this.UP_GOROUTER(index);
      this["$router"].push(url);
    }
  }
  public tagClick(item: objAny) {
    this["$router"].push(item.url);
  }
  public routerClick(item: objAny) {
    console.log(item);
    this["$router"].push(item.url);
  }

  public goBack() {
    this.win.history.go(-1);
  }
}
